// Copyright (c) 2024-2026, Schweizer Alpen-Club. This file is part of
// hitobito and licensed under the Affero General Public License version 3
// or later. See the COPYING file at the top-level directory or at
// https://github.com/hitobito/hitobito

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "organizationToggle"];

  toggle(event) {
    this.toggleTarget.classList.toggle("hidden");
  }

  toggleOrganization(event) {
    this.organizationToggleTarget.classList.toggle("hidden");
  }
}
